"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "giaglione": {
    "132dd54d": [{
      "hkey": "21dd63e7",
      "slug": "san-giovanni",
      "name": "San Giovanni",
      "primary": true,
      "skipSearch": false
    }],
    "1d0218bd": [{
      "hkey": "3bcc3b27",
      "slug": "pradonio",
      "name": "Pradonio",
      "primary": true,
      "skipSearch": false
    }],
    "35286b83": [{
      "hkey": "ad09e7bc",
      "slug": "giaglione",
      "name": "Giaglione",
      "primary": true,
      "skipSearch": false
    }],
    "55022aa2": [{
      "hkey": "ad09e7bc",
      "slug": "giaglione",
      "name": "Giaglione",
      "primary": true,
      "skipSearch": false
    }],
    "56ef9506": [{
      "hkey": "15ab47b1",
      "slug": "san-giuseppe",
      "name": "San Giuseppe",
      "primary": true,
      "skipSearch": false
    }],
    "67923573": [{
      "hkey": "ad09e7bc",
      "slug": "giaglione",
      "name": "Giaglione",
      "primary": true,
      "skipSearch": false
    }],
    "716fefe7": [{
      "hkey": "845b90e3",
      "slug": "sant-anna-sant-antonio-san-rocco",
      "name": "Sant'Anna-Sant'Antonio-San Rocco",
      "primary": true,
      "skipSearch": false
    }],
    "8af790a8": [{
      "hkey": "60dcf4ef",
      "slug": "san-gregorio",
      "name": "San Gregorio",
      "primary": true,
      "skipSearch": false
    }],
    "a03711e2": [{
      "hkey": "845b90e3",
      "slug": "sant-anna-sant-antonio-san-rocco",
      "name": "Sant'Anna-Sant'Antonio-San Rocco",
      "primary": false,
      "skipSearch": false
    }],
    "a06b2293": [{
      "hkey": "845b90e3",
      "slug": "sant-anna-sant-antonio-san-rocco",
      "name": "Sant'Anna-Sant'Antonio-San Rocco",
      "primary": false,
      "skipSearch": false
    }],
    "a4d4705f": [{
      "hkey": "75c30191",
      "slug": "santo-stefano",
      "name": "Santo Stefano",
      "primary": true,
      "skipSearch": false
    }],
    "abbe2b36": [{
      "hkey": "fad2fe8a",
      "slug": "creusa-rastella",
      "name": "Creusa-Rastella",
      "primary": true,
      "skipSearch": false
    }],
    "breida": [{
      "hkey": "ad09e7bc",
      "slug": "giaglione",
      "name": "Giaglione",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c0464c4a": [{
      "hkey": "c12b11e5",
      "slug": "sant-andrea",
      "name": "Sant'Andrea",
      "primary": true,
      "skipSearch": false
    }],
    "cornale-cournaa": [{
      "hkey": "ad09e7bc",
      "slug": "giaglione",
      "name": "Giaglione",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "creusa-viacroeza": [{
      "hkey": "fad2fe8a",
      "slug": "creusa-rastella",
      "name": "Creusa-Rastella",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "giaglione"
    }],
    "d132fdde": [{
      "hkey": "ad09e7bc",
      "slug": "giaglione",
      "name": "Giaglione",
      "primary": true,
      "skipSearch": false
    }],
    "d5cc4a74": [{
      "hkey": "00d75cf4",
      "slug": "san-lorenzo",
      "name": "San Lorenzo",
      "primary": true,
      "skipSearch": false
    }],
    "d9ac31a7": [{
      "hkey": "ad09e7bc",
      "slug": "giaglione",
      "name": "Giaglione",
      "primary": true,
      "skipSearch": false
    }],
    "f99417a1": [{
      "hkey": "fad2fe8a",
      "slug": "creusa-rastella",
      "name": "Creusa-Rastella",
      "primary": true,
      "skipSearch": false
    }],
    "moulee": [{
      "hkey": "ad09e7bc",
      "slug": "giaglione",
      "name": "Giaglione",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "paru": [{
      "hkey": "ad09e7bc",
      "slug": "giaglione",
      "name": "Giaglione",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "pradonio-pradone": [{
      "hkey": "3bcc3b27",
      "slug": "pradonio",
      "name": "Pradonio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "rastella-ratela": [{
      "hkey": "fad2fe8a",
      "slug": "creusa-rastella",
      "name": "Creusa-Rastella",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "giaglione"
    }],
    "san-giovanni-grimoun": [{
      "hkey": "21dd63e7",
      "slug": "san-giovanni",
      "name": "San Giovanni",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "san-giuseppe-poueizat": [{
      "hkey": "15ab47b1",
      "slug": "san-giuseppe",
      "name": "San Giuseppe",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "san-gregorio-tsamberlan": [{
      "hkey": "60dcf4ef",
      "slug": "san-gregorio",
      "name": "San Gregorio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "san-lorenzo-plan": [{
      "hkey": "00d75cf4",
      "slug": "san-lorenzo",
      "name": "San Lorenzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "san-rocco-cree": [{
      "hkey": "845b90e3",
      "slug": "sant-anna-sant-antonio-san-rocco",
      "name": "Sant'Anna-Sant'Antonio-San Rocco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "giaglione"
    }],
    "sant-andrea-cloo": [{
      "hkey": "c12b11e5",
      "slug": "sant-andrea",
      "name": "Sant'Andrea",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "sant-anna-seintana": [{
      "hkey": "845b90e3",
      "slug": "sant-anna-sant-antonio-san-rocco",
      "name": "Sant'Anna-Sant'Antonio-San Rocco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "giaglione"
    }],
    "sant-antonio-vilo": [{
      "hkey": "845b90e3",
      "slug": "sant-anna-sant-antonio-san-rocco",
      "name": "Sant'Anna-Sant'Antonio-San Rocco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "santo-stefano-staqueven": [{
      "hkey": "75c30191",
      "slug": "santo-stefano",
      "name": "Santo Stefano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "tseina": [{
      "hkey": "ad09e7bc",
      "slug": "giaglione",
      "name": "Giaglione",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;